enum LevelStatus {
  START = 'start',
  INPROGRESS = 'inprogress',
  LOCKED = 'locked',
  GAMEOVER = 'gameover',
}

export default LevelStatus;
